import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(1.5 1.5) translate(0 1)">
    <rect fill={fill} />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
      <rect
        x="3.33203"
        y="0.613281"
        width="9.71734"
        height="11.2791"
        fill="url(#pattern0)"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
        <path
          d="M12.0767 0.65625H4.25366C3.98413 0.65625 3.76562 0.874751 3.76562 1.14429V10.5977C3.76562 10.8673 3.98413 11.0858 4.25366 11.0858H12.0767C12.3462 11.0858 12.5647 10.8673 12.5647 10.5977V1.14429C12.5647 0.874751 12.3462 0.65625 12.0767 0.65625Z"
          fill="white"
        />
      </g>
    </g>
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.12">
      <rect
        x="3.55859"
        y="0.492188"
        width="9.28354"
        height="10.8453"
        fill="url(#pattern1)"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.12">
        <path
          d="M12.0806 0.65625H4.25757C3.98803 0.65625 3.76953 0.874751 3.76953 1.14429V10.5977C3.76953 10.8673 3.98803 11.0858 4.25757 11.0858H12.0806C12.3501 11.0858 12.5686 10.8673 12.5686 10.5977V1.14429C12.5686 0.874751 12.3501 0.65625 12.0806 0.65625Z"
          fill="white"
        />
      </g>
    </g>
    <path
      d="M8.33207 0.652344H4.25787C4.19395 0.652342 4.13066 0.664991 4.07165 0.689561C4.01264 0.714131 3.95908 0.750137 3.91405 0.795503C3.86902 0.840869 3.83341 0.894699 3.80928 0.95389C3.78515 1.01308 3.77297 1.07646 3.77345 1.14038V3.25882H8.33207V0.652344Z"
      fill="#21A366"
    />
    <path
      d="M12.0881 0.652344H8.33203V3.25882H12.5653V1.14038C12.5663 1.01252 12.5166 0.889466 12.4273 0.798044C12.3379 0.706622 12.216 0.654248 12.0881 0.652344Z"
      fill="#33C481"
    />
    <path
      d="M12.5689 5.86719H8.33203V8.47366H12.5689V5.86719Z"
      fill="#107C41"
    />
    <path
      d="M8.33207 8.47366V5.86719H3.77345V10.5921C3.77297 10.6563 3.78526 10.72 3.80962 10.7794C3.83398 10.8389 3.86991 10.8929 3.91532 10.9383C3.96074 10.9837 4.01473 11.0196 4.07416 11.044C4.13358 11.0683 4.19726 11.0806 4.26149 11.0801H12.0881C12.1524 11.0806 12.216 11.0683 12.2755 11.044C12.3349 11.0196 12.3889 10.9837 12.4343 10.9383C12.4797 10.8929 12.5157 10.8389 12.54 10.7794C12.5644 10.72 12.5767 10.6563 12.5762 10.5921V8.47366H8.33207Z"
      fill="#185C37"
    />
    <path
      d="M8.33177 3.26172H3.76953V5.86819H8.33177V3.26172Z"
      fill="#107C41"
    />
    <path
      d="M12.5689 3.26172H8.33203V5.86819H12.5689V3.26172Z"
      fill="#21A366"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.48">
      <rect
        y="2.30859"
        width="8.24239"
        height="8.15563"
        fill="url(#pattern2)"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.48">
        <path
          d="M6.5394 2.93359H1.64819C1.37866 2.93359 1.16016 3.1521 1.16016 3.42163V8.31284C1.16016 8.58237 1.37866 8.80087 1.64819 8.80087H6.5394C6.80894 8.80087 7.02744 8.58237 7.02744 8.31284V3.42163C7.02744 3.1521 6.80894 2.93359 6.5394 2.93359Z"
          fill="white"
        />
      </g>
    </g>
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.24">
      <rect
        x="0.960938"
        y="2.83594"
        width="6.33363"
        height="6.24686"
        fill="url(#pattern3)"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.24">
        <path
          d="M6.5394 2.93359H1.64819C1.37866 2.93359 1.16016 3.1521 1.16016 3.42163V8.31284C1.16016 8.58237 1.37866 8.80087 1.64819 8.80087H6.5394C6.80894 8.80087 7.02744 8.58237 7.02744 8.31284V3.42163C7.02744 3.1521 6.80894 2.93359 6.5394 2.93359Z"
          fill="white"
        />
      </g>
    </g>
    <path
      d="M6.5394 2.93359H1.64819C1.37866 2.93359 1.16016 3.1521 1.16016 3.42163V8.31284C1.16016 8.58237 1.37866 8.80087 1.64819 8.80087H6.5394C6.80894 8.80087 7.02744 8.58237 7.02744 8.31284V3.42163C7.02744 3.1521 6.80894 2.93359 6.5394 2.93359Z"
      fill="#107C41"
    />
    <path
      d="M2.6875 7.45529L3.70334 5.86827L2.7598 4.28125H3.51897L4.03231 5.29347C4.07931 5.38747 4.11184 5.45977 4.12992 5.50676C4.16245 5.43085 4.1986 5.35493 4.23476 5.28263L4.78425 4.28125H5.48196L4.52035 5.86827L5.51088 7.46975H4.78786L4.19137 6.35992C4.16427 6.31258 4.14129 6.26299 4.12269 6.2117V6.2117C4.10542 6.26238 4.08237 6.3109 4.054 6.35631L3.41052 7.45529H2.6875Z"
      fill="white"
    />
    <g style={{ mixBlendMode: 'soft-light' }} opacity="0.5">
      <path
        style={{ mixBlendMode: 'soft-light' }}
        opacity="0.5"
        d="M6.5394 2.93359H1.64819C1.37866 2.93359 1.16016 3.1521 1.16016 3.42163V8.31284C1.16016 8.58237 1.37866 8.80087 1.64819 8.80087H6.5394C6.80894 8.80087 7.02744 8.58237 7.02744 8.31284V3.42163C7.02744 3.1521 6.80894 2.93359 6.5394 2.93359Z"
        fill="url(#paint0_linear_2918_183556)"
      />
    </g>
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_2918_183556"
          transform="scale(0.00884956 0.00763359)"
        />
      </pattern>
      <pattern
        id="pattern1"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image1_2918_183556"
          transform="scale(0.00925926 0.00793651)"
        />
      </pattern>
      <pattern
        id="pattern2"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image2_2918_183556" transform="scale(0.0104167)" />
      </pattern>
      <pattern
        id="pattern3"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image3_2918_183556" transform="scale(0.0135135)" />
      </pattern>
      <linearGradient
        id="paint0_linear_2918_183556"
        x1="2.17961"
        y1="2.55039"
        x2="6.00798"
        y2="9.18046"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopOpacity="0.7" />
      </linearGradient>
      <image
        id="image0_2918_183556"
        width="113"
        height="131"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACDCAYAAAC6JPTCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0ElEQVR4Xu3YTU8TURiG4fsUbIsf+BWJGnXBwhh3/v8fYmKMGGPUGEXkS6jOHBfvOe1UxrKxRZ48d3JS6ExZcPGemSHlnHGXu/XzTgBIKaX65cIT3b8uA+RzJi0tOl7wBmWtlVdDrqYMtEBTXtu/YfYiFrxETOoQGJc1IjANudwygXcKnJQ1AX4RgzmHdgaxM31D4BpwE7gL3AGul/c9kcurTuAEOAR2ga/AHnBc3p+byrlrYgdwTODdBx4DT4AHwO1ybA23zBpi+r4BH4B3ZX0E9okJ7UckpmsIbBJ4z8raJkA3iS11gFtmLQG1T8C9JnZFiC21SSn9rNM4RSxTuAZsAFvAU+AF8Bx4xGwK1/FWuuwygXVCXMqul/ePgAMCuCnrzCQOmCFuE5Db5QdtMLtDdcuvJX7nw/L9AfCprO/AaUqpzTnnLmKdxBGxbW6VdQu4ClzBE7jK6qPdNWKIHpZ1h7hOHhLTemaq6mPFiICrfwl+rLiY6vP5mBis28ANZvclqZ70Z3Ui/YD/fzRgNlhjeoZq0fXNcP9P3f+cnRkq36RcrnoHy4gCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGfFylfveXITY+wF3IWWg7aw5mz7EDDTl5Ppq0Iup4v0CToGT8trQMVnv+VD9wDHwA5gAo3I84VZZS/z+j4A9YBc4JHymw9VFrBN4CuwDn8u6WY4P8TV0ldWBOgI+Au+A98BXYriaeuKfk9iWEz4Db5gBbgEbwBpuVbXEQO0RgC+BHeALsa22Oef5Scw555RSwwzxVTn0nUC8ihFXWUNg7RITuAO8JVAnBDIAqWDGNyklYsscA5sE3j1iIkflmK+Ly6/e0EyAAwLyCwF4DPzMOfcjwhzkkNhCNwjAdQy4yuo1cULsjifl66YLCD2IMIVMxPY5KK8GXH11Iuuj3vQ62K0XcXowMMGAF1mGuGf52wkLEd3l6DfHVuwii6DFdAAAAABJRU5ErkJggg=="
      />
      <image
        id="image1_2918_183556"
        width="108"
        height="126"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB+CAYAAADBePRdAAAACXBIWXMAAC4jAAAuIwF4pT92AAACb0lEQVR4Xu3XzXHaUBhG4XMJSxtKIAWkhbiANOAC0lN6SAMU4GxcAAVACYC38ZeFJFvDzzKId+acjcTVZfXMJy6tqjittTY7W7SbVVXv1561MVhrrQELYAU8AO3K9+z/VMAbsAOOl+A+wHqsJfAdeKZDE+y2FR3WGtgA26o6jDe0qhpjPQE/++sCm6IjsAVegV/AZjxp8/66oJusAWuJ0zVVS+Bbf/9CN3H74eGsP2Cs6F6DYt1HX4CvwA9gNT4EDjePdGgLxLqXBpPH8eL4+C7U/XVm4v+tsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLawxWV3fZVJ2ZDGBHYAccLm2ySRpMjuPFWVW99w9+Ay/AHtGm7i+wBdbArjcCYN5fD8AfoPWfn4AFNkVHOqxXYMPJhM0Bqqpaa3u6Cat+04pPQLtNRfe2W9NhbcfTBdCqPt9+rbVGN1kr4AHBbl0Bb/S/XadYcAL2sdiax/0JuwQ1dBHM7rd/jp90H8g9bqAAAAAASUVORK5CYII="
      />
      <image
        id="image2_2918_183556"
        width="96"
        height="95"
        xlinkHref="data:image/png;base64,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"
      />
      <image
        id="image3_2918_183556"
        width="74"
        height="73"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABJCAYAAACaRLDfAAAACXBIWXMAAC4jAAAuIwF4pT92AAABy0lEQVR4Xu3cMVLCUBSF4f8ylKI7EHvXoDuwdwOuTXtXIKyB3rgDwZpncfMMJOCcmnf+hglkmMk3ScoTpRRqERHAAlgCV0DQRgX4ATpgVw5R+qJ+1yNdA4/AM4nVElQHvAErYDvGmsME6QV46I9b6p58mgBWEXGENe8/FwxIjyRSK3dT7Ya89toHsK0H84iYkY/ZM8Od1BoS5DVfkwY74DMiNqWUPcCsP6m+wFtFqlWsJcNjCAxQ9SSXTSwOodw/GUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlK7BBqMi7VcBOLCrUjh6a2p05qqEIadKTJX7N+9qeuca2Bb2A//ocG2pPXviYtujqJBMPQ1o6cLIPcervnxDTQBVefqA3wSloc3VHjjbsFcEdCPQG3XP5cUgG+gHcS6pMTg4AxOqZfKFuQSC0sJ9bFxC8S6ORrZwL190OCNdM5oNpZKHfcL4k/bZY4tSNlAAAAAElFTkSuQmCC"
      />
    </defs>
  </g>
);

export default Icon;
